 <!--设置站点-->
<template>
  <el-dialog ref="setStation" title="设置站点" :visible.sync="visible" :append-to-body="true" width="50%" :before-close="handleClose">
    <el-table :load="loading" :data="data" :border="false" height="280px">
      <el-table-column label="序号" prop="index" width="50" type="index" align="center"></el-table-column>
      <el-table-column label="类型" prop="type" width="80" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.index === start">
            起点
          </div>
          <div v-if="scope.row.index > 0 && scope.row.index < end">
            经过
          </div>
          <div v-if="scope.row.index === end">
            终点
          </div>
        </template>
      </el-table-column>
      <el-table-column label="站点名称" prop="stationName" width="120" align="center"></el-table-column>
      <el-table-column label="上下规则" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.rule | rulesFilters }}</span>
        </template>
      </el-table-column>
      <el-table-column label="关闭站点" align="center" prop="isOpen">
        <template slot-scope="scope">
          <avue-switch
              :active-color="activeColor"
              v-model="scope.row.isOpen"
              :dic="[{ value: 2 }, { value: 1 }]">
          </avue-switch>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="cancel">取 消</el-button>
      <el-button type="primary" size="small" @click="save">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { getStationRule } from '@/api/transport/bustime'
  export default {
    name: "setStation",
    filters: {
      rulesFilters(rule) {
        let mark = ''
        switch (rule) {
          case 1:
            mark = '上车'
            break
          case 2:
            mark = '下车'
            break
          case 3:
            mark = '上下车'
            break
        }
        return mark
      }
    },
    components: {},
    data() {
      return {
        visible: true,
        loading: true,
        activeColor: '#13ce66',
        openDisabled: false,
        start: 0, // 默认起点
        end: 0, // 终点计算列表长度
        data: [],
        openData: [],
        type: '',
        tableIndex: '',
        form: {

        },
        selectiondAll: { // 选中所有数据
          stationNameGroup: '',
          stationName: '', // 站点名称
          data: [],// 站点数据
        }
      }
    },
    methods: {
      init(row) {
        this.visible = true
        this.type = row.type
        this.tableIndex = row.index
        this.form = row.column
        // 先判断是否是生成班次页面对应时间段设置
        if (row.isChecked) {
         this.getBeforeStationRule(this.form.stationConfigVos)
        } else {
          this.getStationRule(row.lineId, row.merchantId)
        }
      },
      async getStationRule(lineId, merchantId) {
        const params = {
          current: 1,
          lineId: lineId,
          merchantId: merchantId,
          size: 10
        }
        await getStationRule(params).then(resp => {
          const list = resp.data
          if (list) {
            list.forEach((item, index) => {
              const fields = {
                index: index,
                stationId: item.stationId,
                stationName: item.stationName,
                rule: item.rule,
                stationRuleId: Number.parseInt(item.stationRuleId),
                startSellTime: item.startSellTime,
                endSellTime: item.endSellTime,
                isOpen: item.isOpen,
                openPickUp: item.openPickUp,
                pickUpRule: item.pickUpRule,
                pickUpTime: item.pickUpTime,
                pickUpType: item.pickUpType,
                sort: item.sort
              }
              this.data.push(fields)
            })
            this.end = this.data.length - 1
          }
        })
      },
      // 获取选中后的数据
      getBeforeStationRule(list) {
        if (list) {
          let items = []
          list.forEach((item, index) => {
            const fields = {
              index: index,
              stationId: item.stationId,
              stationName: item.stationName,
              rule: item.rule,
              stationRuleId: Number.parseInt(item.stationRuleId),
              startSellTime: item.startSellTime,
              endSellTime: item.endSellTime,
              isOpen: item.isOpen,
              openPickUp: item.openPickUp,
              pickUpRule: item.pickUpRule,
              pickUpTime: item.pickUpTime,
              pickUpType: item.pickUpType,
              sort: item.sort
            }
            items.push(fields)
          })
          this.data = items.filter(p => p.isOpen === 1)
        }
        this.end = this.data.length - 1
      },
      save() {
        if (this.data) {
          if(this.data.filter(p => p.isOpen === 2 && p.rule === 1).length === this.data.filter(p => p.rule === 1).length ||
            this.data.filter(p => p.isOpen === 2 && p.rule === 2).length === this.data.filter(p => p.rule === 2).length) {
            this.$message.warning("请至少保留一个上车点和下车点")
            return;
          }

          this.data.filter(p => p.isOpen === 1).forEach(item => {
            this.selectiondAll.stationName += item.stationName + '-'
          })

          this.selectiondAll.stationNameGroup = `${this.data.filter(p => p.isOpen === 1).length} 个站点：` + this.selectiondAll.stationName.substring(0, this.selectiondAll.stationName.lastIndexOf('-'))
          this.selectiondAll.data = this.data

          // 获取站点规则编辑
          if (this.type === 'SET') {
            this.form.stationNameGroup = this.selectiondAll.stationNameGroup
            this.form.stationConfigVos = this.data
            this.$store.commit('UPDATE_PLAN_TIME_ROW_STATIONRULE', this.form )
          }
          this.$emit('LineFormData', this.selectiondAll)
          this.selectiondAll = {
            stationNameGroup: '',
            stationName: '', // 站点名称
            data: [],// 站点数据
          }
          this.data = []
          this.visible = false
        }
      },
      cancel() {
        this.visible = false
        this.data = []
      },
      handleClose(done) {
        this.data = []
        done()
      }
    }
  }
</script>

<style scoped>

</style>
